import { ProductRepository } from "../../../../data/repository/product/ProductRepository";
import { Message } from "../../../model/Auth";
import { ResponseState, State } from "../../../model/ResponseState";

export interface EditDeliveryPriceUseCase {
  invoke: (price: number) => Promise<ResponseState<Message>>;
}

export class EditDeliveryPriceUseCaseImpl implements EditDeliveryPriceUseCase {
  private repo: ProductRepository;

  constructor(repo: ProductRepository) {
    this.repo = repo;
  }

  async invoke(price: number): Promise<ResponseState<Message>> {
    try {
      let response = await this.repo.editDeliveryPrice(price);
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
